import { FETCH_POP_COUNT,FETCH_LIVESERVICE_COUNT,FETCH_USERACTIVITY_COUNT, FETCH_CUSTOMER_AM, FETCH_QUICK_LINKS, FETCH_PENDING_ACTION_DATA, FETCH_INCIDENT_DASHBOARD_DATA, FETCH_DEMAND_DASHBOARD_DATA, FETCH_ONBOARDED_CUSTOMER_COUNT, FETCH_ONBOARDING_REQUEST_DATA, FETCH_SCHEDULED_BROADCAST_MESSAGE, FETCH_CUSTOMER_DETAILS_WIDGET, FETCH_CUSTOMER_PRIMARY_CONTACT, FETCH_SELECTED_CUSTOMER_AM, FETCH_CUSTOMER_APPROVER_WIDGET, FETCH_STATUS_WISE_CUSTOMER_USERS_COUNT, FETCH_STATUS_WISE_INTERNAL_USERS_COUNT } from "../actionTypes";
import { fetchDashboarddata } from "../../../api/home/home.service";

const requestPop = ()=>({type: FETCH_POP_COUNT.REQUEST})
const failurePop = (error)=>({type: FETCH_POP_COUNT.FAILURE, error})
const successPop = (obj)=>({type: FETCH_POP_COUNT.SUCCESS, obj})


export const getPopsCount = (action)=>{
    return (dispatch, getState)=>{        
        dispatch(requestPop())
        return fetchDashboarddata(action)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successPop(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failurePop(error?.message))
            return Promise.resolve(false)
        })
    }
}
const requestLiveServiceCount = ()=>({type: FETCH_LIVESERVICE_COUNT.REQUEST})
const failureLiveServiceCount = (error)=>({type: FETCH_LIVESERVICE_COUNT.FAILURE, error})
const successLiveServiceCount = (obj)=>({type: FETCH_LIVESERVICE_COUNT.SUCCESS, obj})


export const getLiveServiceCount = (action)=>{
    return (dispatch, getState)=>{        
        dispatch(requestLiveServiceCount())
        return fetchDashboarddata(action)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successLiveServiceCount(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureLiveServiceCount(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestUserActivity = ()=>({type: FETCH_USERACTIVITY_COUNT.REQUEST})
const failureUserActivity = (error)=>({type: FETCH_USERACTIVITY_COUNT.FAILURE, error})
const successUserActivity = (obj)=>({type: FETCH_USERACTIVITY_COUNT.SUCCESS, obj})


export const getUserActivityCount = (action)=>{
    return (dispatch, getState)=>{        
        dispatch(requestUserActivity())
        return fetchDashboarddata(action)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successUserActivity(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureUserActivity(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestOnboardedCustomerCount = ()=>({type: FETCH_ONBOARDED_CUSTOMER_COUNT.REQUEST})
const failureOnboardedCustomerCount = (error)=>({type: FETCH_ONBOARDED_CUSTOMER_COUNT.FAILURE, error})
const successOnboardedCustomerCount = (obj)=>({type: FETCH_ONBOARDED_CUSTOMER_COUNT.SUCCESS, obj})


export const getOnboardedCustomerCount = (action)=>{
    return (dispatch, getState)=>{        
        dispatch(requestOnboardedCustomerCount())
        return fetchDashboarddata(action)
        .then(response => {
            let obj={
                'data':response.data,
            }
            dispatch(successOnboardedCustomerCount(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureOnboardedCustomerCount(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestIncidentGraph = ()=>({type: FETCH_INCIDENT_DASHBOARD_DATA.REQUEST})
const failureIncidentGraph = (error)=>({type: FETCH_INCIDENT_DASHBOARD_DATA.FAILURE, error})
const successIncidentGraph = (obj)=>({type: FETCH_INCIDENT_DASHBOARD_DATA.SUCCESS, obj})

export const getIncidentGraph = (action,filterOptions,uniqueCustomerRefId,startDate,endDate)=>{
    return (dispatch, getState)=>{        
        dispatch(requestIncidentGraph())
        return fetchDashboarddata(action,filterOptions,uniqueCustomerRefId,startDate,endDate)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successIncidentGraph(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureIncidentGraph(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestDemandGraph = ()=>({type: FETCH_DEMAND_DASHBOARD_DATA.REQUEST})
const failureDemandGraph = (error)=>({type: FETCH_DEMAND_DASHBOARD_DATA.FAILURE, error})
const successDemandGraph = (obj)=>({type: FETCH_DEMAND_DASHBOARD_DATA.SUCCESS, obj})

export const getDemandGraph = (action,filterOptions,uniqueCustomerRefId,startDate,endDate)=>{
    return (dispatch, getState)=>{        
        dispatch(requestDemandGraph())
        return fetchDashboarddata(action,filterOptions,uniqueCustomerRefId,startDate,endDate)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successDemandGraph(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureDemandGraph(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestOnboardingData = ()=>({type: FETCH_ONBOARDING_REQUEST_DATA.REQUEST})
const failureOnboardingData = (error)=>({type: FETCH_ONBOARDING_REQUEST_DATA.FAILURE, error})
const successOnboardingData = (obj)=>({type: FETCH_ONBOARDING_REQUEST_DATA.SUCCESS, obj})

export const getOnboardingData = (action,filterOptions,uniqueCustomerRefId,startDate,endDate)=>{
    return (dispatch, getState)=>{        
        dispatch(requestOnboardingData())
        return fetchDashboarddata(action,filterOptions,uniqueCustomerRefId,startDate,endDate)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successOnboardingData(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureOnboardingData(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestPendingActionData = ()=>({type: FETCH_PENDING_ACTION_DATA.REQUEST})
const failurePendingActionData = (error)=>({type: FETCH_PENDING_ACTION_DATA.FAILURE, error})
const successPendingActionData = (obj)=>({type: FETCH_PENDING_ACTION_DATA.SUCCESS, obj})

export const getPendingActionData = (action)=>{
    return (dispatch, getState)=>{        
        dispatch(requestPendingActionData())
        return fetchDashboarddata(action)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successPendingActionData(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failurePendingActionData(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestQuickLinks = ()=>({type: FETCH_QUICK_LINKS.REQUEST})
const failureQuickLinks = (error)=>({type: FETCH_QUICK_LINKS.FAILURE, error})
const successQuickLinks = (obj)=>({type: FETCH_QUICK_LINKS.SUCCESS, obj})


export const getQuickLinks = (action)=>{
    return (dispatch, getState)=>{        
        dispatch(requestQuickLinks())
        return fetchDashboarddata(action)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successQuickLinks(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureQuickLinks(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestScheduledBroadcast = ()=>({type: FETCH_SCHEDULED_BROADCAST_MESSAGE.REQUEST})
const failureScheduledBroadcast = (error)=>({type: FETCH_SCHEDULED_BROADCAST_MESSAGE.FAILURE, error})
const successScheduledBroadcast = (obj)=>({type: FETCH_SCHEDULED_BROADCAST_MESSAGE.SUCCESS, obj})

export const getScheduledBroadcast = (action)=>{
    return (dispatch, getState)=>{        
        dispatch(requestScheduledBroadcast())
        return fetchDashboarddata(action)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successScheduledBroadcast(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureScheduledBroadcast(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestAM = ()=>({type: FETCH_CUSTOMER_AM.REQUEST})
const failureAM = (error)=>({type: FETCH_CUSTOMER_AM.FAILURE, error})
const successAM = (obj)=>({type: FETCH_CUSTOMER_AM.SUCCESS, obj})

export const getCustomerAm = (action)=>{
    return (dispatch, getState)=>{        
        dispatch(requestAM())
        return fetchDashboarddata(action)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successAM(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureAM(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestCustomerData = ()=>({type: FETCH_CUSTOMER_DETAILS_WIDGET.REQUEST})
const failureCustomerData = (error)=>({type: FETCH_CUSTOMER_DETAILS_WIDGET.FAILURE, error})
const successCustomerData = (obj)=>({type: FETCH_CUSTOMER_DETAILS_WIDGET.SUCCESS, obj})

export const getCustomerData = (action,filterOptions,uniqueCustomerRefId)=>{
    return (dispatch, getState)=>{        
        dispatch(requestCustomerData())
        return fetchDashboarddata(action,filterOptions,uniqueCustomerRefId)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successCustomerData(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureCustomerData(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestCustomerPrimaryContact = ()=>({type: FETCH_CUSTOMER_PRIMARY_CONTACT.REQUEST})
const failureCustomerPrimaryContact = (error)=>({type: FETCH_CUSTOMER_PRIMARY_CONTACT.FAILURE, error})
const successCustomerPrimaryContact = (obj)=>({type: FETCH_CUSTOMER_PRIMARY_CONTACT.SUCCESS, obj})

export const getCustomerPrimaryContact = (action,filterOptions,uniqueCustomerRefId)=>{
    return (dispatch, getState)=>{        
        dispatch(requestCustomerPrimaryContact())
        return fetchDashboarddata(action,filterOptions,uniqueCustomerRefId)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successCustomerPrimaryContact(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureCustomerPrimaryContact(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestSelectedCustAM = ()=>({type: FETCH_SELECTED_CUSTOMER_AM.REQUEST})
const failureSelectedCustAM = (error)=>({type: FETCH_SELECTED_CUSTOMER_AM.FAILURE, error})
const successSelectedCustAM = (obj)=>({type: FETCH_SELECTED_CUSTOMER_AM.SUCCESS, obj})

export const getSelectedCustAM = (action,filterOptions,uniqueCustomerRefId)=>{
    return (dispatch, getState)=>{        
        dispatch(requestSelectedCustAM())
        return fetchDashboarddata(action,filterOptions,uniqueCustomerRefId)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successSelectedCustAM(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureSelectedCustAM(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestSelectedCustApprover = ()=>({type: FETCH_CUSTOMER_APPROVER_WIDGET.REQUEST})
const failureSelectedCustApprover = (error)=>({type: FETCH_CUSTOMER_APPROVER_WIDGET.FAILURE, error})
const successSelectedCustApprover = (obj)=>({type: FETCH_CUSTOMER_APPROVER_WIDGET.SUCCESS, obj})

export const getSelectedCustApprover = (action,filterOptions,uniqueCustomerRefId)=>{
    return (dispatch, getState)=>{        
        dispatch(requestSelectedCustApprover())
        return fetchDashboarddata(action,filterOptions,uniqueCustomerRefId)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successSelectedCustApprover(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureSelectedCustApprover(error?.message))
            return Promise.resolve(false)
        })
    }
}

const requestCustomerUserCount = ()=>({type: FETCH_STATUS_WISE_CUSTOMER_USERS_COUNT.REQUEST})
const failureCustomerUserCount = (error)=>({type: FETCH_STATUS_WISE_CUSTOMER_USERS_COUNT.FAILURE, error})
const successCustomerUserCount = (obj)=>({type: FETCH_STATUS_WISE_CUSTOMER_USERS_COUNT.SUCCESS, obj})

export const getCustomerUserCount = (action,filterOptions,uniqueCustomerRefId)=>{
    return (dispatch, getState)=>{        
        dispatch(requestCustomerUserCount())
        return fetchDashboarddata(action,filterOptions,uniqueCustomerRefId)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successCustomerUserCount(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureCustomerUserCount(error?.message))
            return Promise.resolve(false)
        })
    }
}


const requestInternalUserCount = ()=>({type: FETCH_STATUS_WISE_INTERNAL_USERS_COUNT.REQUEST})
const failureInternalUserCount = (error)=>({type: FETCH_STATUS_WISE_INTERNAL_USERS_COUNT.FAILURE, error})
const successInternalUserCount = (obj)=>({type: FETCH_STATUS_WISE_INTERNAL_USERS_COUNT.SUCCESS, obj})

export const getInternalUserCount = (action,uniqueCustomerRefId)=>{
    return (dispatch, getState)=>{        
        dispatch(requestInternalUserCount())
        return fetchDashboarddata(action,uniqueCustomerRefId)
        .then(response => {
            let obj={
                'data':response.data,
            }    
            dispatch(successInternalUserCount(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failureInternalUserCount(error?.message))
            return Promise.resolve(false)
        })
    }
}